<a mat-button [style.background]="color" [href]="source.url">
  <mat-card-content>
    <img *ngIf="logo" [src]="logo" class="logo" [class.svg]="logo.endsWith('.svg')">
  </mat-card-content>
</a>